import type { EstateItem } from "@/shared/types/estateTypes";

interface CardDisplay {
  title: string;
  subtitle: string | null;
}

export function getCardDisplay(item: EstateItem): CardDisplay {
  const last4 = item.plaid_account_mask || (item.identifiers?.account_last4 as string | undefined);
  const masked4 = last4 ? `····${last4}` : null;
  const meta = (item.metadata ?? {}) as Record<string, unknown>;
  const cat = item.category;

  const parts = (...args: (string | null | undefined)[]) =>
    args.filter(Boolean).join(" · ") || null;

  if (cat === "Properties") {
    return {
      title: item.item_name,
      subtitle: item.item_type || null,
    };
  }

  if (cat === "Vehicles") {
    return {
      title: item.item_name,
      subtitle: parts(
        meta.make as string,
        meta.model as string,
        meta.year ? String(meta.year) : null,
      ),
    };
  }

  const accountEnding = last4 ? `Account ending ··${last4}` : null;

  if (
    [
      "Bank accounts",
      "Brokerage accounts",
      "Tax-advantaged savings",
      "Retirement accounts",
      "Crypto accounts",
    ].includes(cat)
  ) {
    return {
      title: item.item_name,
      subtitle: parts(item.item_type, accountEnding),
    };
  }

  if (["Life insurance", "Long-term care insurance", "Annuity contracts"].includes(cat)) {
    return {
      title: item.item_name,
      subtitle: parts(item.item_type, masked4),
    };
  }

  if (["Unsecured Debts", "Secured debts"].includes(cat)) {
    return {
      title: item.item_name,
      subtitle: parts(item.item_type, accountEnding),
    };
  }

  if (["Valuables", "Safe or safety deposit box"].includes(cat)) {
    return {
      title: item.item_name,
      subtitle: item.item_type || null,
    };
  }

  if (
    ["LLC or partnership interest", "Stock in a private company", "Sole proprietorship"].includes(
      cat,
    )
  ) {
    return {
      title: item.item_name,
      subtitle: item.item_type || null,
    };
  }

  return {
    title: item.item_name,
    subtitle: parts(item.item_type, accountEnding),
  };
}
